var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.103 1.604a.561.561 0 1 1 .794.793l-1.75 1.75-.039-.043-.752-.753zM6.65 4.058 1.952 8.756l-.265 1.057 1.058-.264 4.7-4.7-.044-.038zM10.603.896a1.56 1.56 0 0 0-2.207 0l-7.249 7.25-.098.098-.033.135-.501 2-.203.808.809-.202 2-.5.135-.033.098-.098 7.25-7.25c.61-.61.61-1.598 0-2.208",
    clipRule: "evenodd"
  })));
});
const SvgEditsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjEwMzE5IDEuNjAzNzhDOS4zMjIyMSAxLjM4NDc0IDkuNjc3MzIgMS4zODQ2NyA5Ljg5NjQyIDEuNjAzNjNDMTAuMTE1NiAxLjgyMjY4IDEwLjExNTcgMi4xNzc5NyA5Ljg5NjU1IDIuMzk3MDlMOC4xNDY3NyA0LjE0Njg3QzguMTM0OSA0LjEzMTkxIDguMTIyMDUgNC4xMTc0NyA4LjEwODIyIDQuMTAzNjNMNy4zNTU4OSAzLjM1MTNMOS4xMDMxOSAxLjYwMzc4Wk02LjY0ODgyIDQuMDU4NDVMMS45NTE5NyA4Ljc1NTg4TDEuNjg3MTcgOS44MTNMMi43NDQ5NiA5LjU0ODY4TDcuNDQ0MzUgNC44NDkzQzcuNDI5MzggNC44Mzc0MiA3LjQxNDk1IDQuODI0NTcgNy40MDExMSA0LjgxMDc0TDYuNjQ4ODIgNC4wNTg0NVpNMTAuNjAzMyAwLjg5NjI5M0M5Ljk5MzYxIDAuMjg3MDA3IDkuMDA1NDkgMC4yODcxOTcgOC4zOTYwNCAwLjg5NjcxOUwxLjE0Njk5IDguMTQ2NjVMMS4wNDkxNyA4LjI0NDQ5TDEuMDE1NTUgOC4zNzg2OUwwLjUxNDU3NSAxMC4zNzg3TDAuMzEyMDEyIDExLjE4NzRMMS4xMjA4IDEwLjk4NTNMMy4xMjE3OCAxMC40ODUzTDMuMjU2MTcgMTAuNDUxN0wzLjM1NDEyIDEwLjM1MzdMMTAuNjAzNyAzLjEwNDJDMTEuMjEzNCAyLjQ5NDQ2IDExLjIxMzIgMS41MDU4MyAxMC42MDMzIDAuODk2MjkzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";